import { Component, OnInit } from '@angular/core';
import { WizardStep } from '../../../../wizard/wizard.component';
import { OrderBatchLogisticsWizardService } from '../../../../services/wizard/logistic/order-batch-send-wizard.service';
import { CacheFilterService } from '../../../../services/cache/cache-filter.service';
import { SectorFilter } from '../../../../model/sector-filter';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FilterCompleteService } from 'src/app/filter-complete/filter-complete';

@Component({
  selector: 'app-send-order-logistics-detail',
  templateUrl: './send-order-logistics-detail.component.html',
  styleUrls: ['./send-order-logistics-detail.component.css']
})
export class SendOrderLogisticsDetailComponent implements OnInit, WizardStep {
  isInit: boolean;
  form: FormGroup;
  sectors: SectorFilter[];
  filterCompleteSectorSend: FilterCompleteService<SectorFilter>;
  filterCompleteSectorReceiver: FilterCompleteService<SectorFilter>;
  constructor(private cacheFilterService: CacheFilterService
    , private formBuilder: FormBuilder
    , private orderBatchSendWizardService: OrderBatchLogisticsWizardService) {

      this.CreateForm();
  }

  private CreateForm() {
    this.form = this.formBuilder.group({
      OrderBatchGuide: [''],
      EntityNameGuide: [{ value: '', disabled: true }],
      PlanNameGuide: [{ value: '', disabled: true }],
      TaxNameGuide: [{ value: '', disabled: true }],
      OrderBatch: this.formBuilder.group({
        Description: [''],
        Name: ['', [Validators.required]],
        CreateDate: [''],
        DeliveryDate: [''],
        ReceptionDate: [{ value: '', disabled: this.orderBatchSendWizardService.isReceiving() }, [Validators.required]],
        DeleteDate: [''],
        UpdateDate: [''],
        Deleted: [''],
        Id: [''],
        BatchStateId: [''],
        SectorSend: [{ value: '', disabled: true }, [Validators.required]],
        SectorReceiver: [{ value: '', disabled: this.orderBatchSendWizardService.isReceiving() }, [Validators.required]],
        CreateUser: [''],
        PlanId: [''],
        TaxId: [''],
        EntityId: [''],
        UpdateUser: [''],
        DeleteUser: [''],
      })
    });
    this.filterCompleteSectorSend = new FilterCompleteService<SectorFilter>([], this.fOrderBatch.SectorSend);
    this.filterCompleteSectorReceiver = new FilterCompleteService<SectorFilter>([], this.fOrderBatch.SectorReceiver);
  }

  get valid(): boolean {
    return this.completed;
  }

  get completed(): boolean { return this.form.valid; }
  get orderBatchGroup() { return <FormGroup>this.form.get('OrderBatch'); }
  get fOrderBatch() { return (<FormGroup>this.form.get('OrderBatch')).controls; }
  get f() { return this.form.controls; }
  get filteredSectorReceiverOptions() { return this.filterCompleteSectorReceiver ? this.filterCompleteSectorReceiver.filteredOptions : []; }
  get filteredSectorSendOptions() { return this.filterCompleteSectorSend ? this.filterCompleteSectorSend.filteredOptions : []; }

  activate(): void {
    this.CreateForm();
    const orderBatchEditInfo = this.orderBatchSendWizardService.getOrderBatchEditInfo();

    this.form.patchValue({
      OrderBatchGuide: orderBatchEditInfo.OrderBatchGuide,
      EntityNameGuide: orderBatchEditInfo.EntityNameGuide,
      PlanNameGuide: orderBatchEditInfo.PlanNameGuide,
      TaxNameGuide: orderBatchEditInfo.TaxNameGuide,
    });

    this.orderBatchGroup.patchValue({
      Description: orderBatchEditInfo.OrderBatch.Description,
      Name: orderBatchEditInfo.OrderBatch.Name,
      CreateDate: orderBatchEditInfo.OrderBatch.CreateDate,
      DeliveryDate: orderBatchEditInfo.OrderBatch.DeliveryDate,
      ReceptionDate: orderBatchEditInfo.OrderBatch.ReceptionDate,
      DeleteDate: orderBatchEditInfo.OrderBatch.DeleteDate,
      UpdateDate: orderBatchEditInfo.OrderBatch.UpdateDate,
      Deleted: orderBatchEditInfo.OrderBatch.Deleted,
      Id: orderBatchEditInfo.OrderBatch.Id,
      BatchStateId: orderBatchEditInfo.OrderBatch.BatchStateId,
      SectorSend: orderBatchEditInfo.OrderBatch.SectorSend,
      SectorReceiver: orderBatchEditInfo.OrderBatch.SectorReceiver,
      CreateUser: orderBatchEditInfo.OrderBatch.CreateUser,
      PlanId: orderBatchEditInfo.OrderBatch.PlanId,
      TaxId: orderBatchEditInfo.OrderBatch.TaxId,
      EntityId: orderBatchEditInfo.OrderBatch.EntityId,
      UpdateUser: orderBatchEditInfo.OrderBatch.UpdateUser,
      DeleteUser: orderBatchEditInfo.OrderBatch.DeleteUser,
    });

    this.cacheFilterService.getSectorFilters().then((sectorFilters) => {
      this.sectors = sectorFilters;
      this.filterCompleteSectorSend = new FilterCompleteService<SectorFilter>(sectorFilters, this.fOrderBatch.SectorSend);
      this.filterCompleteSectorReceiver = new FilterCompleteService<SectorFilter>(sectorFilters, this.fOrderBatch.SectorReceiver);
    });

    this.form.valueChanges.subscribe(() => {
      this.orderBatchSendWizardService.setOrderBatch(
        this.orderBatchGroup.getRawValue()
      );
    });
  }

  save(): void {

  }

  ngOnInit(): void {
    this.isInit = true;

  }
}
